import { Heading, Skeleton } from '@digdir/designsystemet-react';

import styled from '../../../styled';

import {
  BreadcrumbsWrapper,
  MainContentWrapper,
  PageLayout,
  SidebarPageLayout,
  SidebarWrapper
} from './styledComponents';

const LoaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
  max-width: var(--content-width);
  width: 100%;
`;

export const PageContentLoader = () => {
  return (
    <LoaderContent>
      <Heading data-size="lg">
        <Skeleton variant="text" width={20} />
      </Heading>
      <Skeleton variant="rectangle" width="740px" height="200px" />
      <Skeleton variant="rectangle" width="740px" height="100px" />
    </LoaderContent>
  );
};

export const SidebarPageLoader = () => {
  return (
    <SidebarPageLayout>
      <BreadcrumbsWrapper>
        <Skeleton width={20} variant="text" />
      </BreadcrumbsWrapper>
      <SidebarWrapper>
        <Skeleton variant="rectangle" width="200px" height="415px" />
      </SidebarWrapper>
      <MainContentWrapper>
        <PageContentLoader />
      </MainContentWrapper>
    </SidebarPageLayout>
  );
};

export const PageLoader = () => {
  return (
    <PageLayout>
      <BreadcrumbsWrapper>
        <Skeleton width={20} variant="text" />
      </BreadcrumbsWrapper>
      <MainContentWrapper>
        <PageContentLoader />
      </MainContentWrapper>
    </PageLayout>
  );
};
